var exports = {
  "k": "xf0b3b88a--599f53--container",
  "u": "xf0b3b88a--599f53--section",
};

module.exports = exports;
